import { SharpieImageConfig } from '../../../../common/helpers/sharpie/useSharpie';

export const heroArticleImageConfig: SharpieImageConfig = {
  desktop: {
    width: 750,
    height: 400,
  },
  tablet: {
    width: 705,
    height: 376,
  },
  mobile: {
    width: 375,
    height: 250,
  },
};
